import React from 'react'
import ffffff from '../image/ffffff.avif'
import { styled } from '@mui/system'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

const useStyles = styled((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}))
function P_FAQ_page() {
  return (
    <div>
      <div className="mt-5">
        <div className="container pt-3">
          <div className="text-center Curriculum_Main_text">
            <div className="">
              <h2 className="display-6">Frequently Asked Questions</h2>
              <p className="pt-2">
                Our Responses to Your Inquiries
              </p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-5">
              <div className="FAQ_img">
                <img
                  src={ffffff}
                  onContextMenu={(e) => e.preventDefault()}
                ></img>
              </div>
            </div>
            <div className="col-md-7 pt-5 d-none d-md-block">
              <div className="pt-5">
                <div className="pt-5">
                  <div className="pt-5">
                    <P_FAQ />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 d-sm-block d-md-none mb-5">
              <P_FAQ />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

function P_FAQ() {
  const classes = useStyles()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false)
  }
  return (
    <>
      <div className={classes.root}>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              Why should students consider studying Psychology?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Because it opens up opportunities to help people, explore human behavior, and build careers in healthcare, education, corporate sectors, research, and law enforcement.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2bh-content"
            id="panel2bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What skills can I gain by studying Psychology?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              You’ll develop critical thinking, empathy, communication, research ability, problem-solving, and analytical skills that are valuable in any career.
             
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel3bh-content"
            id="panel3bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How does Psychology help in professional careers outside healthcare?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            
              In fields like business, marketing, education, law, and technology, psychology helps understand human behavior, improving outcomes and performance.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel4bh-content"
            id="panel4bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              How is Psychology connected with Neuroscience?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
            
              Neuroscience studies the brain’s biological processes, while Psychology studies behavior. Together, they explain how brain activity influences thoughts and actions.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          className="py-2"
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel5bh-content"
            id="panel5bh-header"
            className="FAQ_background_color"
          >
            <Typography style={{ fontSize: '1.2rem' }}>
              What makes Psychology a growing career field?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Increasing awareness about mental health, workplace well-being, and human behavior has made Psychology one of the fastest-growing professions globally.
            
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </>
  )
}
export default P_FAQ_page
